import React, { cloneElement, Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Button,
  Modal
} from 'react-bootstrap';
import Conditional from '../Conditional';
import SubmitButton from '../SubmitButton';
import actionsAndConstants from '../../shared/actionsAndConstants';

const { app: { actions: appActions } } = actionsAndConstants;

const actions = {
  clearDialog: appActions.clearDialog
};

const initialState = { submitting: false };

class Dialog extends Component {
  state = initialState

  handleOnConfirm = () => {
    this.props.onConfirm();
    this.setState({ submitting: true });
  }

  handleOnExited = () => {
    const {
      actions: { clearDialog },
      dialogId
    } = this.props;
    clearDialog({ id: dialogId });
  }

  render() {
    const {
      children,
      dialogId,
      onHide,
      show,
      showButtons,
      size,
      title
    } = this.props;
    const { submitting } = this.state;
    return (
      <Modal
        backdrop="static"
        bsSize={size}
        onExited={this.handleOnExited}
        keyboard={false}
        show={show}
        onHide={onHide}
      >
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{cloneElement(children, { dialogId })}</Modal.Body>
        <Conditional condition={showButtons}>
          <Modal.Footer>
            <Button
              disabled={submitting}
              bsStyle="danger"
              onClick={onHide}
            >
              Cerrar
            </Button>
            <SubmitButton
              onClick={this.handleOnConfirm}
              submitText="Procesando"
              submitting={submitting}
              text="Confirmar"
              type="button"
            />
          </Modal.Footer>
        </Conditional>
      </Modal>
    );
  }
}

Dialog.propTypes = {
  actions: PropTypes.shape({
    clearDialog: PropTypes.func.isRequired
  }).isRequired,
  children: PropTypes.node,
  dialogId: PropTypes.string.isRequired,
  onConfirm: PropTypes.func,
  onHide: PropTypes.func,
  show: PropTypes.bool,
  showButtons: PropTypes.bool,
  size: PropTypes.string,
  title: PropTypes.string
};

Dialog.defaultProps = {
  children: null,
  onConfirm: () => {},
  onHide: () => {},
  show: true,
  showButtons: false,
  size: null,
  title: ''
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(null, mapDispatchToProps)(Dialog);



// WEBPACK FOOTER //
// ./src/components/Dialog/index.js